import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_EXPENSE} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const ExpenseSearch = lazy(() =>
  import('../../../screens/ExpenseSearch')
    .then(module => ({default: module.ExpenseSearch})));

const ExpenseSearchNavigation = [
  {
    path: ROUTE_EXPENSE,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ExpenseSearch />
      </Suspense>
    ),
  },
];

export default ExpenseSearchNavigation;
